import script from "./UIBtn.vue?vue&type=script&lang=ts&setup=true"
export * from "./UIBtn.vue?vue&type=script&lang=ts&setup=true"

import "./UIBtn.vue?vue&type=style&index=0&id=62d61942&lang=stylus&scoped=true"

import exportComponent from "/codebuild/output/src024011243/src/2022-meta-acrossthemetaverse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62d61942"]])

export default __exports__